const packs = [
    {
        name: "Publicación individual",
        qty: 1,
        price: { clp: 2, usd: 99 },
        packCode: "B01I01",
        featured: false,
    },
    {
        name: "Pack 3",
        qty: 3,
        price: { clp: 1.66, usd: 85 },
        packCode: "B11P03",
        featured: false,
    },
    {
        name: "Pack 5",
        qty: 5,
        price: { clp: 1.4, usd: 77 },
        packCode: "B12P05",
        featured: false,
    },
    {
        name: "Pack 10",
        qty: 10,
        price: { clp: 1, usd: 63 },
        packCode: "B13P10",
        featured: false,
    },
    {
        name: "Publicación individual",
        qty: 1,
        price: { clp: 3, usd: 148 },
        packCode: "F01I01",
        featured: true,
    },
    {
        name: "Pack 3",
        qty: 3,
        price: { clp: 2.33, usd: 118 },
        packCode: "F11P03",
        featured: true,
    },
    {
        name: "Pack 5",
        qty: 5,
        price: { clp: 2, usd: 105 },
        packCode: "F12P05",
        featured: true,
    },
    {
        name: "Pack 10",
        qty: 10,
        price: { clp: 1.6, usd: 82 },
        packCode: "F13P10",
        featured: true,
    },
];

const packsDesc = packs.map(({ name, packCode, featured }) => 
    ({ name: featured ? `${name} destacado` : name, code: packCode })
);

export {
    packs,
    packsDesc
};
